import { useMutation } from "react-query";
import api from "../../client";
import { Institution } from "../../types/institution";

const deleteData = async (id: string | undefined): Promise<Institution> => {
  const { data } = await api.delete(`/institutions/${id}`);

  return data;
};

export const useDeleteInstitution = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
